import { motion } from 'motion/react';
import { LabsHeaderContainer } from './labs-header-container';

interface LabsHeaderNoOrderProps {
  onOrderClick: () => void;
  className?: string;
}

export function LabsHeaderNoOrder({ onOrderClick, className }: LabsHeaderNoOrderProps) {
  return (
    <LabsHeaderContainer className={className}>
      <div className="flex min-h-[250px] flex-col justify-center">
        <motion.h1
          className="mb-4 text-center text-2xl font-bold leading-tight text-white md:text-left md:text-[44px] md:font-normal md:leading-[56px] md:tracking-[0.3px]"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Order Your Free Annual Labs
        </motion.h1>

        <motion.p
          className="mb-8 max-w-[900px] text-[20px] font-normal leading-[1.3] text-white"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        >
          <span className="hidden md:inline">
            Get clinical lab results integrated into your unique cancer risk profile for a more accurate, complete
            view of your health. Your membership includes an annual blood panel of 50+ biomarkers at no extra cost.
          </span>
          <span className="md:hidden">
            Your membership includes an annual blood panel and take the next step toward understanding your health.
          </span>
        </motion.p>

        <motion.button
          onClick={onOrderClick}
          className="flex h-10 w-fit items-center justify-center rounded-full bg-[#7cf1c7] px-6 text-[14px] font-bold text-[#183344] transition-all hover:opacity-90"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Order Your Lab Visit
        </motion.button>
      </div>
    </LabsHeaderContainer>
  );
}
